module.exports = __webpack_public_path__ + "img/lens-167-plus-02.01c9047a.png";